import { setConfiguration } from "@configuratorware/configurator-frontendgui/App/configuration";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import ConfiguratorScreen from "./App/Screens/ConfiguratorScreen";
import ConfiguratorService from "./App/Services/ConfiguratorService";
import InteractionService from "./App/Services/InteractionService";
import DesignDataService from "./App/Services/DesignDataService";
import configuratorReducer from "./App/Reducers/Configurator/Reducer";

const prod = process.env.NODE_ENV === "production";

const envDomains = {
  test: "",
  int: "http://int.schoeffel-pro.local",
  local: "http://localhost:10620",
  prod: "",
};

const domain = envDomains[prod ? "prod" : "int"];

const query = new URLSearchParams(location.search);

const adminMode = query.get("_adminmode");

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}/`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
  },
  reducers: {
    configurator: configuratorReducer,
  },
  services: {
    InteractionService,
    ConfiguratorService,
    DesignDataService,
  },
  designer: {
    allowedImageUploadFormats: "eps,ai",
  },
  showStartHere: false,
  disableBeforeunloadWarning: true,
};

setConfiguration(customApplicationConfiguration);
if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader("no-cache");
}

export default customApplicationConfiguration;
